export default {
  "nav.spreadsheet": "Regneark",
  "nav.products": "Produkter",
  "nav.sellers": "Sælgere",
  "nav.reviews": "Anmeldelser",
  "nav.shipping": "Forsendelse",
  "nav.guides": "Guider",
  "nav.safety": "Sikkerhed",
  "nav.home": "Forside",
  "nav.shoppingGuide": "Købsguide",
  "nav.categories": "Kategorier",
  "nav.cta": "Besøg hovedsiden",

  "hero.badge": "Uafhængig købsressource",
  "hero.title": "AllChinaBuy Spreadsheet — Opdag produkter, sælgere og købsguider",
  "hero.subtitle":
    "Udforsk organiserede AllChinaBuy-regneark, produktfund, sælgerressourcer, QC-guider, forsendelsesinfo, anmeldelser og praktiske købsvejledninger — alt på ét sted.",
  "hero.searchPlaceholder": "Søg efter produkter, sælgere, kategorier eller AllChinaBuy-guider…",
  "hero.ctaPrimary": "allchinabuy spreadsheet",
  "hero.ctaSecondary": "køb nu",
  "hero.trust": "Uafhængig købsressource • Opdateret indhold • Praktiske guider • Sikkerhedsfokuseret research",

  "categories.label": "Gennemse efter kategori",
  "categories.title": "Find det, du har brug for, hurtigere",
  "categories.subtitle":
    "Gå direkte til den sektion af hovedbutikken, du har brug for — hver kategori nedenfor åbner den matchende produktliste.",

  "featured.title": "Din komplette AllChinaBuy Spreadsheet-ressource",
  "featured.subtitle":
    "Undersøg først, og fortsæt derefter til hovedsiden, når du er klar. Disse guider dækker de emner, købere oftest spørger om.",
  "featured.spreadsheet.title": "AllChinaBuy Spreadsheet",
  "featured.spreadsheet.desc":
    "Gennemse organiserede produktressourcer og populære kategorier.",
  "featured.review.title": "AllChinaBuy anmeldelse",
  "featured.review.desc":
    "Forstå platformen, omkostninger, funktioner, styrker og begrænsninger.",
  "featured.shipping.title": "AllChinaBuy forsendelsesomkostninger",
  "featured.shipping.desc":
    "Lær, hvordan vægt, mål, destination og forsendelseslinjer påvirker omkostningerne.",
  "featured.qc.title": "AllChinaBuy QC",
  "featured.qc.desc":
    "Forstå QC-billeder, inspektion og kontrol inden forsendelse.",
  "featured.warehouse.title": "AllChinaBuy lager",
  "featured.warehouse.desc":
    "Lær, hvordan lager, inspektion og konsolidering fungerer.",
  "featured.safety.title": "AllChinaBuy sikkerhed",
  "featured.safety.desc":
    "Lær at identificere falske hjemmesider, phishing og risikable sælgere.",

  "searches.title": "Populære søgninger",
  "searches.subtitle": "De spørgsmål og emner, læserne oftest søger efter.",
  "searches.item1": "AllChinaBuy anmeldelse",
  "searches.item2": "AllChinaBuy forsendelsesomkostninger",
  "searches.item3": "AllChinaBuy kupon",
  "searches.item4": "AllChinaBuy rabatkode",
  "searches.item5": "AllChinaBuy lager",
  "searches.item6": "AllChinaBuy ægte",

  "why.title": "Hvorfor bruge denne ressource",
  "why.subtitle": "Skabt til at gøre køb fra Kina klarere, sikrere og lettere at sammenligne.",
  "why.point1.title": "Organiserede kategorier",
  "why.point1.desc": "Hver produkttype er grupperet, så du hurtigt finder et realistisk prisleje.",
  "why.point2.title": "Originale guider",
  "why.point2.desc": "Forklaringer i klart sprog skrevet til rigtige købere, ikke genbrugt fyld.",
  "why.point3.title": "Sikkerhed først",
  "why.point3.desc": "Praktiske råd om at spotte falske sider, phishing og risikable sælgere.",
  "why.point4.title": "Direkte til butikken",
  "why.point4.desc": "Klare udgående links fører dig til præcis den sektion, du har brug for, når du er klar.",

  "articles.title": "Seneste artikler",
  "articles.subtitle": "Originale, dybdegående guider om AllChinaBuy-regnearket.",
  "articles.readMore": "Læs guiden",
  "articles.cardTitle": "AllChinaBuy Spreadsheet: Den komplette 2026-guide",
  "articles.cardDesc":
    "Produkter, sælgere, QC-billeder og forsendelse — sådan organiserer du hver ordre i ét klart, sorterbart ark.",

  "faq.title": "Ofte stillede spørgsmål",
  "faq.subtitle": "Hurtige svar på de spørgsmål, købere oftest stiller.",
  "faq.q1": "Hvad er et AllChinaBuy-regneark?",
  "faq.a1":
    "Det er et selvorganiseret sporingsark til ordrer via en kinesisk købsplatform — med produkter, sælgere, priser, QC-status og forsendelsesdetaljer i én sorterbar visning.",
  "faq.q2": "Er dette den officielle AllChinaBuy-hjemmeside?",
  "faq.a2":
    "Nej. Dette er en uafhængig informationsressource uden officiel tilknytning. Kontrollér altid den aktuelle officielle platform direkte.",
  "faq.q3": "Har jeg brug for et regneark til små ordrer?",
  "faq.a3":
    "Ikke nødvendigvis, men et simpelt ark hjælper stadig med at sammenligne den samlede pris på tværs af sælgere og holde QC- og vægtnoter ét sted.",
  "faq.q4": "Hvilke kategorier kan jeg gennemse her?",
  "faq.a4":
    "Sko, hættetrøjer, t-shirts, jakker, bukser, hovedbeklædning, sæt, undertøj, trøjer, tilbehør, tasker, bælter, parfumer og mere — hver med link til den matchende sektion af hovedbutikken.",

  "cta.title": "Klar til at udforske mere?",
  "cta.text":
    "Brug vores guider til at undersøge først, og fortsæt derefter til hovedsiden, når du er klar.",
  "cta.button": "Gå til hovedsiden",

  "footer.tagline": "Den komplette produkt-, sælger-, QC- og købsressource",
  "footer.disclaimer":
    "Dette er en uafhængig informationshjemmeside og er ikke tilknyttet eller godkendt af AllChinaBuy. Priser, forsendelse og politikker ændres — kontrollér altid den aktuelle officielle platform.",
  "footer.resourcesTitle": "Ressourcer",
  "footer.legalTitle": "Juridisk",
  "footer.languagesTitle": "Sprog",
  "footer.about": "Om os",
  "footer.editorial": "Redaktionel politik",
  "footer.safety": "Sikkerhedscenter",
  "footer.disclaimerLink": "Ansvarsfraskrivelse",
  "footer.privacy": "Privatlivspolitik",
  "footer.terms": "Vilkår",
  "footer.contact": "Kontakt",
  "footer.sitemap": "Sitemap",
  "footer.mainSite": "Hovedside",
  "footer.rights": "Alle rettigheder forbeholdes.",

  "category.shoes": "Sko",
  "category.hoodies": "Hættetrøjer / Sweatshirts",
  "category.tshirts": "T-shirts",
  "category.jackets": "Jakker",
  "category.pants": "Bukser / Shorts",
  "category.headwear": "Hovedbeklædning",
  "category.sets": "Sæt",
  "category.underwear": "Undertøj",
  "category.jersey": "Trøjer",
  "category.accessories": "Tilbehør",
  "category.bags": "Tasker",
  "category.belts": "Bælter",
  "category.perfumes": "Parfumer",
  "category.other": "Andet",

  "article.notFound": "Artikel ikke fundet",
  "article.summary": "Resumé",
  "article.backHint": "Vend tilbage til forsiden for at gennemse alle kategorier og guider.",

  "category.guide": "Guide",
  "category.review": "Anmeldelse",
  "category.safety": "Sikkerhed",
  "category.shipping": "Forsendelse",
  "category.warehouse": "Lager",
  "category.qc": "Kvalitetskontrol",
  "category.coupons": "Kuponer",
  "category.comparison": "Sammenligning",
  "category.beginners": "Begyndere",
};